import React, { useState, useEffect } from "react";
import { Box, Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { OffensivePlayLog, RosterPlayer } from "../../../../types/LogTypes";
import { PlayerSelection } from "../Components/PlayerSelection";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { YardlineInput } from "../Components/YardlineInput";

export const OffenseTurnoverLog = () => {
  const {
    selectedGame,
    gameSituation,
    setGameSituation,
    currentPlayLog,
    setCurrentPlayLog,
  } = useLogger();
  const { ballCarriers, receivers } = useDepthChart();
  const [ballReturnedTo, setBallReturnedTo] = useState(gameSituation.yardline);
  const [turnoverType, setTurnoverType] = useState<
    "fumble" | "interception" | null
  >(null);
  const [selectedPlayer, setSelectedPlayer] = useState<RosterPlayer | null>(
    null
  );
  const [jerseyNumber, setJerseyNumber] = useState<string>("");

  const players = [...ballCarriers, ...receivers];
  const handleTurnoverTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTurnoverType(event.target.value as "fumble" | "interception");
    setSelectedPlayer(null);
  };

  const handleJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumber(value);
    }
  };

  const handleTurnoverPlayerSelection = (player: RosterPlayer) => {
    setSelectedPlayer(player);
    setJerseyNumber(player.jersey_number?.toString() || "");
  };

  useEffect(() => {
    if (turnoverType === "fumble") {
      setCurrentPlayLog({
        ...currentPlayLog,
        fumble: {
          fumble_roster_player: selectedPlayer,
          fumble_club: selectedGame?.user_club,
          fumble_recovery_club: selectedGame?.opponent_club,
        },
      } as OffensivePlayLog);
    }
    if (turnoverType === "interception") {
      setCurrentPlayLog({
        ...currentPlayLog,
        interception: {
          passer_roster_player: selectedPlayer,
          turnover_club: selectedGame?.user_club,
          takeaway_club: selectedGame?.opponent_club,
        },
      } as OffensivePlayLog);
    }
  }, [turnoverType, selectedPlayer]);

  useEffect(() => {
    setGameSituation({
      ...gameSituation,
      yardline: ballReturnedTo,
    });
  }, [ballReturnedTo]);

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Turnover Type */}
        <Grid item xs={2}>
          <RadioGroup value={turnoverType} onChange={handleTurnoverTypeChange}>
            <FormControlLabel
              value="fumble"
              control={<Radio />}
              label="Fumble"
            />
            <FormControlLabel
              value="interception"
              control={<Radio />}
              label="Interception"
            />
          </RadioGroup>
        </Grid>

        {/* Player */}
        <Grid item xs={7}>
          <PlayerSelection
            title="Turnover By"
            players={players}
            selectedPlayer={selectedPlayer}
            jerseyNumber={jerseyNumber}
            maxDisplayedPlayers={5}
            handlePlayerSelection={handleTurnoverPlayerSelection}
            handleJerseyNumberChange={handleJerseyNumberChange}
          />
        </Grid>
        {/* Ball Returned To */}
        <Grid item xs={3}>
          <YardlineInput
            value={ballReturnedTo}
            onChange={setBallReturnedTo}
            label="Ball Returned To"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
